import { Badge, Box, Button, Flex, IconButton, Table, Tbody, Td, Th, Thead, Tr, useDisclosure, useToast } from '@chakra-ui/react';
import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import Card from 'components/card/Card';
import { queryClient } from 'index';
import { deleteProductGroup, findProductGroups, ProductGroup } from 'services/api.service';
import GroupFormModal from './components/GroupFormModal';

export default function CatalogGroups() {
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [editingId, setEditingId] = useState<string | undefined>(undefined);
  const { data: groups, isLoading } = useQuery(['productGroups'], findProductGroups);

  const openCreate = () => {
    setEditingId(undefined);
    onOpen();
  };
  const openEdit = (id: string) => {
    setEditingId(id);
    onOpen();
  };
  const remove = async (id: string) => {
    if (!window.confirm('Remover este grupo?')) return;
    try {
      await deleteProductGroup(id);
      await queryClient.invalidateQueries({ queryKey: ['productGroups'] });
      toast({ title: 'Grupo removido', status: 'success', duration: 4000, isClosable: true });
    } catch (err: any) {
      toast({
        title: 'Erro',
        description: err?.response?.data?.message || 'Erro ao remover',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const sumPct = (g: ProductGroup) => (g.splits || []).reduce((a, s) => a + Number(s.percentage), 0);

  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <Card>
        <Flex justify="space-between" align="center" mb={4}>
          <Box fontSize="lg" fontWeight="bold">
            Grupos do catálogo
          </Box>
          <Button colorScheme="brand" onClick={openCreate}>
            Criar grupo
          </Button>
        </Flex>
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>Nome</Th>
              <Th>Split dinheiro</Th>
              <Th>Recebedores</Th>
              <Th>Total %</Th>
              <Th>Ações</Th>
            </Tr>
          </Thead>
          <Tbody>
            {(groups || []).map((g) => (
              <Tr key={g.id}>
                <Td>{g.name}</Td>
                <Td>{g.applyCashSplit ? <Badge colorScheme="green">Sim</Badge> : <Badge>Não</Badge>}</Td>
                <Td>{(g.splits || []).length}</Td>
                <Td>{sumPct(g)}%</Td>
                <Td>
                  <Flex gap={2}>
                    <IconButton
                      aria-label="Editar"
                      icon={<EditIcon />}
                      size="sm"
                      variant="outline"
                      onClick={() => openEdit(g.id)}
                    />
                    <IconButton
                      aria-label="Remover"
                      icon={<DeleteIcon />}
                      size="sm"
                      colorScheme="red"
                      variant="outline"
                      onClick={() => remove(g.id)}
                    />
                  </Flex>
                </Td>
              </Tr>
            ))}
            {!isLoading && (groups || []).length === 0 ? (
              <Tr>
                <Td colSpan={5}>Nenhum grupo cadastrado.</Td>
              </Tr>
            ) : null}
          </Tbody>
        </Table>
      </Card>
      {isOpen ? <GroupFormModal isOpen={isOpen} onClose={onClose} groupId={editingId} /> : null}
    </Box>
  );
}
